import Vue from 'vue'

import ModalHeader from './ModalHeader'

Vue.component('modal-header', ModalHeader)
